import React from 'react';
import { motion } from 'framer-motion';
export function Navbar() {
  const scrollToPricing = () => {
    const element = document.getElementById('pricing');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.5
  }} className="fixed top-[56px] sm:top-[40px] left-0 right-0 z-50 bg-navy/95 backdrop-blur-md border-b border-white/10 shadow-lg shadow-black/20" data-id="element-118">
      <div className="max-w-6xl mx-auto px-4 h-20 flex items-center justify-between" data-id="element-119">
        <div className="flex items-center gap-2" data-id="element-120">
          <span className="font-heading font-bold text-xl md:text-2xl text-white tracking-tighter" data-id="element-121">
            IMPERIO <span className="text-gold" data-id="element-122">AMERICANO</span>
          </span>
        </div>

        <button onClick={scrollToPricing} className="hidden md:inline-flex items-center justify-center px-6 py-2.5 bg-gold hover:bg-gold-dark text-navy font-heading font-bold rounded-lg transition-all duration-300 shadow-md hover:shadow-glow transform hover:-translate-y-0.5" data-id="element-123">
          COMPRAR AHORA
        </button>
      </div>
    </motion.nav>;
}